import { render, staticRenderFns } from "./AppLongText.vue?vue&type=template&id=585482b1&scoped=true&"
import script from "./AppLongText.vue?vue&type=script&lang=js&"
export * from "./AppLongText.vue?vue&type=script&lang=js&"
import style0 from "./AppLongText.vue?vue&type=style&index=0&id=585482b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585482b1",
  null
  
)

export default component.exports